var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{class:{ active: _vm.active },attrs:{"icon":_vm.icon,"title":_vm.text,"disabled":!_vm.enabled()},on:{"click":function($event){return _vm.command(_vm.commandArguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }